import { useContext, useMemo } from "react";

import { InputChoiceContext } from "./InputChoiceContext/InputChoiceContext";

export function useInputChoice() {
  const context = useContext(InputChoiceContext);

  if (!context) {
    throw new Error(
      "useInputChoice must be used within an InputChoiceContextProvider."
    );
  }

  return useMemo(() => context, [context]);
}
